import React from 'react';

import i18next from "i18next"


const { compose, withProps, withStateHandlers } = require("recompose");
const {
  withGoogleMap,
  GoogleMap,
  Marker
} = require("react-google-maps");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");
const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");

import _ from 'underscore'

var elevator_icon = require('../../../static/img/elevator_icon.png')
var elevator_icon_excla = require('../../../static/img/elevator_excla.png')

var escalator_icon = require('../../../static/img/escalator_icon.png')
var escalator_icon_excla = require('../../../static/img/escalator_excla.png')
var close_icon = require('../../../static/img/close_icon.png')

var plus_icon = require('../../../static/img/plus_icon.png')

var exclamation_icon = require('../../../static/img/exclamation-sign.png')

var elevator_group_icon = require('../../../static/img/elevator_group.png')
var escalator_group_icon = require('../../../static/img/escalator_group.png')

var elevator_group_conflict_icon = require('../../../static/img/elevator_group_conflict.png')
var escalator_group_conflict_icon = require('../../../static/img/escalator_group_conflict.png')

import './gmap.css'

const STSGoogleMap = compose(
  withProps({
    containerElement: <div className="sts-google-map-container" style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
    center: { lat: 48.85, lng: 2.3 },
  }),
  withStateHandlers((props) => {
    var openedGroups = {}
    _.each(props.groups, (products, gps) => { 
      openedGroups[gps] = false;
    })
    return { openedGroups }
  }, {
    onToggleOpenGroup: (state) => (gps) => {
      return {
        openedGroups: {
          ...state.openedGroups,
          [gps]: !state.openedGroups[gps]
        }
      }
    }
  }),
  withGoogleMap
)(props => {

  var adr_groups = props.groups;

  const { user, push, params, t } = props

  var markers = []

  var index = 0;
  _.each(adr_groups, (products, gps) => {
    index++
    var unique_key = gps

    if (gps == 'null' || gps == null) {
      gps = null
    } else {
      gps = gps.split(',').map(parseFloat)
    }

    //Gerer les groupes
    if (products.length > 1 && gps != null) {
      var conflict = products.filter((p) => p.etat_en_panne || p.etat_en_travaux).length > 0
      var types = products.map((p) => p.identification_type)
      if (types.indexOf('ASC') > -1 || types.indexOf('ASC-IP') > -1) {
        if (conflict) {
          var icon = elevator_group_conflict_icon
        }
        else {
          var icon = elevator_group_icon
        }
      }
      else {
        if (conflict) {
          var icon = escalator_group_conflict_icon
        } else {
          var icon = escalator_group_icon
        }
      }

      var ps = products.map((fiche) => {

        var editProductPath;
        if (user.role == 'client' || user.role == 'demo') {
          editProductPath = '/client/product/' + fiche.id + '/edit'
        } else if (user.role == 'user') {
          editProductPath = '/user/product/' + fiche.id + '/edit'
        } else {
          editProductPath = '/admin/' + params.id + '/product/' + fiche.id + '/edit'
        }

        if (fiche.etat_en_panne) {
          iconClass = "text-danger fa-exclamation-triangle";
          etat = (<span className="text-danger"><b>
            {i18next.t("google_map.en_panne")}
            </b></span>)
          conflict = true
        } else if (fiche.etat_en_travaux) {
          iconClass = "text-danger fa-wrench";
          etat = (<span className="text-warning">
            <b>
              {i18next.t("google_map.en_travaux")}
            </b>
          </span>)
          conflict = true
        } else if (fiche.etat_en_service) {
          iconClass = "text-success fa-circle"
          etat = (<span className="text-success">
            <b>
              {i18next.t("google_map.en_marche")}
            </b>
          </span>)
        }

        return (
          <p>
            {fiche.identification_NUM_ASC != "" ? <div>{fiche.identification_NUM_ASC}</div> : ''}
            {fiche.localisation_adresse != "" ? <div>{fiche.localisation_adresse}</div> : ''}
            {fiche.localisation_adresse_COMP != "" ? <div>{fiche.localisation_adresse_COMP}</div> : ''}
            {fiche.localisation_adresse_COMP2 != "" ? <div>{fiche.localisation_adresse_COMP2}</div> : ''}
            {etat}<br />
            <a onClick={() => push(editProductPath)} style={{ cursor: 'pointer' }}>
              
              {i18next.t("google_map.visualize_sheet")}
              
            </a>
          </p>
        )


      })

      var label = props.openedGroups[unique_key] ?
        <div style={{ background: '#FFFF', borderRadius: '10px', padding: '10px', 'cursor': 'default' }}>
          <img onClick={() => props.onToggleOpenGroup(gps)}
            src={close_icon}
            style={{ cursor: 'pointer', position: 'absolute', zIndex: '100000', top: 0, right: 0 }} />
          <div>
            {ps}
          </div>
        </div> : <span />

      var box = props.openedGroups[unique_key] ?
        <InfoBox
          onCloseClick={() => props.onToggleOpenGroup(unique_key)}
          options={{
            closeBoxMargin: -20000, closeBoxUrl: ``,
            enableEventPropagation: true,
            boxStyle: { 'width': '150px', 'border': '1px solid black', 'border-radius': '10px' }
          }}
        >
          {label}

        </InfoBox> : <span />

      markers.push(
        <Marker
          position={{ lat: gps[0], lng: gps[1] }}
          key={'groupe' + index}
          onClick={() => props.onToggleOpenGroup(unique_key)}
          icon={icon}
          title={products.map((p) => p.identification_NUM_ASC).join('&')}
          label={''}
          options={{
            labelClass: "gmap-label",
            labelInBackground: true
          }}
          animation='DROP'
        >
          {box}
        </Marker>
      )
    }

    else if (products.length == 1 && gps) {

      //Produit seul
      var fiche = products[0];
      var iconClass;
      var etat = '';
      var conflict = false

      if (fiche.etat_en_panne) {
        iconClass = "text-danger fa-exclamation-triangle";
        etat = <span className="text-danger"><b>{i18next.t("google_map.en_panne")}</b></span>
        conflict = true
      } else if (fiche.etat_en_travaux) {
        iconClass = "text-danger fa-wrench";
        etat = <span className="text-warning"><b>{i18next.t("google_map.en_travaux")}</b></span>
        conflict = true
      } else if (fiche.etat_en_service) {
        iconClass = "text-success fa-circle"
        etat = <span className="text-success"><b>{i18next.t("google_map.en_marche")}</b></span>
      }

      else if (fiche.etat_indisponibilite_sts) {
        iconClass = "text-danger fa-exclamation-triangle";
        etat = <span className="text-danger"><b>{i18next.t("google_map.indispo")}</b></span>
        conflict = true
      }
      else {
        iconClass = "fa-circle"
      }

      var icon = `<i className=${iconClass}/>`

      if (fiche.identification_type == 'ASC' || fiche.identification_type == 'ASC-IP') {
        if (conflict) {
          icon = elevator_icon_excla
        } else {
          icon = elevator_icon
        }
      } else {
        if (conflict) {
          icon = escalator_icon_excla
        } else {
          icon = escalator_icon
        }
      }

      if (fiche.localisation_GPS) {

        var editProductPath;
        if (user.role == 'client' || user.role == 'demo') {
          editProductPath = '/client/product/' + fiche.id + '/edit'
        } else if (user.role == 'user') {
          editProductPath = '/user/product/' + fiche.id + '/edit'
        } else {
          editProductPath = '/admin/' + params.id + '/product/' + fiche.id + '/edit'
        }

        var label = props.openedGroups[unique_key] ?
          <div style={{ background: '#FFFF', borderRadius: '10px', padding: '10px', 'cursor': 'default' }}>
            <img onClick={() => props.onToggleOpenGroup(unique_key)}
              src={close_icon}
              style={{ cursor: 'pointer', position: 'absolute', zIndex: '100000', top: 0, right: 0 }} />
            <p>
              {fiche.identification_NUM_ASC != "" ? <div>{fiche.identification_NUM_ASC}</div> : ''}
              {fiche.localisation_adresse != "" ? <div>{fiche.localisation_adresse}</div> : ''}
              {fiche.localisation_adresse_COMP != "" ? <div>{fiche.localisation_adresse_COMP}</div> : ''}
              {fiche.localisation_adresse_COMP2 != "" ? <div>{fiche.localisation_adresse_COMP2}</div> : ''}
              {etat}<br />
              <a onClick={() => push(editProductPath)} style={{ cursor: 'pointer' }}>{i18next.t("google_map.visualize_sheet")}</a>
            </p>
          </div> : <span />


        var gps = fiche.localisation_GPS.split(',').map(parseFloat)


        var box = props.openedGroups[unique_key] ?

          <InfoBox
            onCloseClick={() => props.onToggleOpenGroup(unique_key)}
            options={{
              closeBoxMargin: -20000, closeBoxUrl: ``,
              enableEventPropagation: true,
              boxStyle: { 'width': '150px', 'border': '1px solid black', 'border-radius': '10px' }
            }}
          >
            {label}
          </InfoBox> : <span />

        markers.push(
          <Marker
            position={{ lat: gps[0], lng: gps[1] }}
            key={fiche.id}
            onClick={() => props.onToggleOpenGroup(unique_key)}
            icon={icon}

            title={fiche.identification_NUM_ASC}
            label={''}
            options={{
              labelClass: "gmap-label",
              labelInBackground: true
            }}
            animation='DROP'

          >
            {box}

          </Marker>
        )

      }


    }

  })


  return (
    <GoogleMap
      defaultZoom={5}
      defaultCenter={props.center}

    >

      {/*<MapControl controlPosition={google.maps.ControlPosition.RIGHT_BOTTOM}>
      <p>Legende</p>
    </MapControl>*/}

      <MarkerClusterer
        onClick={props.onMarkerClustererClick}
        averageCenter
        enableRetinaIcons
        gridSize={60}
      >
        {markers}
      </MarkerClusterer>

    </GoogleMap>
  )
}
);

export default STSGoogleMap